import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { createSupport } from "../actions";
import { bootstrapCompanyProjects, loadCompanyProjects } from "../../companies/actions";

type Project = WtdModels.Partial<WtdModels.Project, "id" | "supported" | "support_count">;

export interface SupportStatus {
  supported: boolean;
  supportCount: number;
}

export interface ProjectSupportsState {
  projects: { [key: number]: SupportStatus };
}

function initProjects(projects: Project[]) {
  return projects.reduce(
    (acc, project) => {
      acc[project.id] = { supported: project.supported || false, supportCount: project.support_count };
      return acc;
    },
    {} as ProjectSupportsState["projects"]
  );
}

const projectSupportsReducer = withImmer(
  reducerWithInitialState<ProjectSupportsState>({
    projects: {},
  })
)
  .cases([bootstrapCompanyProjects], (state, action) => {
    state.projects = initProjects(action.projects);
    return state;
  })
  .cases([loadCompanyProjects.done], (state, action) => {
    state.projects = initProjects(action.result.projects);
    return state;
  })
  .case(createSupport.done, (state, action) => {
    const { projectId } = action.params;
    const status = state.projects[projectId as number];
    if (!status.supported) {
      status.supportCount += 1;
    }
    status.supported = true;
    return state;
  });

export default projectSupportsReducer;



// WEBPACK FOOTER //
// ./frontend/src/project_supports/reducers/index.ts